<template>
  <div class="grid-header-container" :style="headerHeight">
    <div class="fiduciary-and-fiduciary-client">
      <selected-fiduciary></selected-fiduciary>
      <div class="vertical-line"></div>
      <client-selector
        :selectedText="selectedClientName"
        :canSelect="canClientSelect"
        @onSelect="toggleClientList"
      />
    </div>
    <transition name="scale">
      <clientList
        v-show="clientListVisible"
        :fiduciary="selectedFiduciary"
        :selectedClient="selectedClient"
        @closeClientList="toggleClientList"
        @updateClientFunds="updateClient"
      />
    </transition>
    <navigation-list
      v-if="selectedClient !== 0"
      :items="allowedTabs"
      :selected="selectedTab"
      @selectedItem="selectTab"
    />
    <search-field :disabled="isSearchDisabled" @onChange="changeSearchTerm" />
  </div>
</template>
<script>
import { get } from 'lodash';
import { mapState } from 'vuex';
import NavigationList from '@/components/atoms/NavigationList';
import ClientList from '@/components/atoms/ClientList';
import SearchField from '@/components/atoms/SearchField';
import ClientSelector from '@/components/atoms/ClientSelector';
import SelectedFiduciary from '@/components/atoms/SelectedFiduciary';
import { getPendingReplacementFlag } from '@/services/PendingReplacements';
import { getFundReviewFlag } from '@/services/FundReview';

export default {
  name: 'grid-header',
  components: {
    ClientSelector,
    ClientList,
    SearchField,
    NavigationList,
    SelectedFiduciary,
  },
  data() {
    return {
      tabs: {
        items: [
          {
            id: 'universe',
            text: 'Universe',
            enabled: () => true,
          },
          {
            id: 'lineups',
            text: 'Lineups',
            enabled: () => true,
          },
          {
            id: 'lineup-changes',
            text: '3(38) Lineup Changes',
            enabled: () => true,
          },
          {
            id: 'replacements-new',
            text: '3(21) Replacements',
            enabled: () => this.selectedClientHasReplacements,
          },
        ],
        selected: 'universe',
      },
    };
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.grid.client.selected,
      selectedClientName: (state) => state.grid.client.name,
      selectedClientHasReplacements: (state) => state.grid.client.hasReplacements,
      clientListVisible: (state) => state.grid.client.listVisible,
      selectedTab: (state) => state.grid.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to 1 Client View
      if (this.currentViewName === 'all-clients') {
        return get(this.policies, `grid.views.${this.currentViewName}`, {});
      }
      return get(this.policies, `grid.views.${this.currentViewName}.tabs.${this.selectedTab}`, {});
    },
    headerHeight() {
      // IE does not recognize the dynamic flex change
      return this.selectedClient ? 'flex: 0 0 111px;' : 'flex: 0 0 60px';
    },
    allowedTabs() {
      // Filter out allowed tabs
      return this.tabs.items.filter((tab) => tab.enabled());
    },
    canClientSelect() {
      return get(this.localPolicyOptions, 'options["select-client"]', false);
    },
    isSearchDisabled() {
      return !get(this.localPolicyOptions, 'options.search', false);
    },
  },
  created() {
    getPendingReplacementFlag().then((result) => {
      if (result?.data?.replacementFlag) {
        const temporaryTab = {
          id: 'replacements',
          text: '3(21) Replacements Old',
          enabled: () => this.selectedClientHasReplacements,
        };
        this.tabs.items.push(temporaryTab);
      }
    });
    getFundReviewFlag().then((result) => {
      if (result?.data?.fundReviewFlag) {
        const temporaryTab = {
          id: 'fund-review',
          text: 'Fund Review Panel',
          enabled: () => true,
        };
        this.tabs.items.push(temporaryTab);
      }
    });
  },
  methods: {
    toggleClientList() {
      if (this.localPolicyOptions.options['select-client']) {
        this.$store.dispatch('setClientListVisible', !this.clientListVisible);
      }
    },
    updateClient(client) {
      // if else loop to decide if the client value is 0(zero or not)
      if (client) {
        // this will route us to one client vue
        this.$router.push({
          name: 'clientGrid',
          params: { clientId: `${client}` },
        }).catch(() => {}); // Avoided redundant navigation error on console
      } else {
        // this will route us to all client vue
        this.$router.push({
          name: 'grid',
        }).catch(() => {}); // Avoided redundant navigation error on console
      }
    },
    selectTab(selected) {
      this.tabs.selected = selected;
      this.$store.dispatch('setTab', selected);
    },
    changeSearchTerm(text) {
      this.$store.dispatch('setSearchTerm', text);
    },
  },
};
</script>
<style lang="scss">
.grid-header-container {
  flex: 0 0 60px;
  position: relative;
  background-color: #12698d;
  color: $mds-color-white;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.1s ease-out;
  transform-origin: top left;
}
.scale-enter,
.scale-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.fiduciary-and-fiduciary-client {
  display: flex;
  flex-direction: row;
  line-height: 0;
}

.vertical-line {
  border-left: $mds-space-quarter-x solid $mds-background-color-white;
  margin: $mds-space-1-x 0 $mds-space-1-x 0;
}
</style>
